<template>
  <GChart type="AreaChart" :data="piChartData" :options="piChartOptions" />
</template>

<script>
import { GChart } from "vue-google-charts";
import Vue from "vue";
export default {
  components: {
    GChart,
  },
  data: function () {
    return {
      piChartData: [["Time", "Index"]],
      piChartOptions: {
        chart: {
          title: "Sectoral PE Ratio",
          subtitle: "PE Ratio of all sectors",
          width: 900,
          height: 500,
        },
      },
      fetchedData: null,
      base_url:
        process.env.NODE_ENV === "production"
          ? "https://apidfl.bicm.ac.bd"
          : "http://localhost:8000",
    };
  },
  methods: {
    loadGraphData() {
      Vue.axios
        .get(this.base_url + "/api/daily-indices-ds30?timestamp=" + new Date().getTime())
        .then((response) => {
          this.fetchedData = response.data.indices;
          this.pushDataToArray();
        });
    },
    pushDataToArray() {
      for (var key in this.fetchedData) {
        var val = this.fetchedData[key];
        this.piChartData.push(val);
      }
      //    this.piChartData.push(this.fetchedData);
    },
  },
  mounted() {
    this.loadGraphData();
  },
};
</script>

<style></style>
